import $ from "jquery";

$(".captcha-refresh").click(function () {
  var $form = $(this).parents("form");
  // var url = location.protocol + "//" + window.location.hostname + ":"
  //           + location.port + "/captcha/refresh/";

  // Make the AJAX-call
  $.getJSON("/captcha/refresh/", {}, function (json) {
    $form.find('input[name="wagtailcaptcha_0"]').val(json.key);
    $form.find("img.captcha").attr("src", json.image_url);
  });

  return false;
});
